export default __webpack_public_path__ + "static/media/scribe.81e34d15.png";